import { Navigate, useLocation } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { createRerouteRegex } from "App/routes/pageNames";
import { AppPagePaths, LegacyPagePaths } from "App/routes/paths";

import { audiencePathResources } from "../audiencePaths";

export default function SegmentsPageRouter(): JSX.Element {
    const { audiencePages } = usePageAvailability();

    if (!audiencePages.showSegments) {
        return <Navigate to={AppPagePaths.fallback} />;
    }

    return <RVNestedRoutingPage />;
}

export function SegmentsRerouter(): JSX.Element {
    const location = useLocation();
    const pathAfterSegments = location.pathname.replace(createRerouteRegex(LegacyPagePaths.segment), "");
    const newPath = pathAfterSegments
        ? `${AppPagePaths.audience}/${audiencePathResources.segments}/${pathAfterSegments}${location.search}${location.hash}`
        : `${AppPagePaths.audience}/${audiencePathResources.segments}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}
